import React from 'react';
import { NavLink } from 'react-router-dom';
import './footer.scss';
import Signup from '../../user/signup/components/Signup';

const Footer = () => (
  <div id="footer">
    <div className="bb-page-wrapper">
      <ul className="footer-links">
        <li className='top-level'>
          <NavLink to='/pricing-guidelines'
            className='bb-main-menu'
            activeClassName='active'>
            Pricing Guidelines
          </NavLink>
        </li>
        <li className='top-level'>
          <NavLink to='/about'
            className='bb-main-menu'
            activeClassName='active'>
            About
          </NavLink>
        </li>
        <li className='top-level'>
          <NavLink to='/terms-and-conditions'
            className='bb-main-menu'
            activeClassName='active'>
            Terms and conditions
          </NavLink>
        </li>
        <li className='top-level'>
          <NavLink to='/privacy'
            className='bb-main-menu'
            activeClassName='active'>
            Privacy
          </NavLink>
        </li>
        <li className='top-level'>
          <Signup
            buttonLabel='Create an Account'
            id="create-account-footer-link"/>
        </li>
      </ul>
    </div>
    <div className="contact-details">
      <p className="contact">beefbook.com</p>
      <p className="contact">phone: +44 1822 820699</p>
    </div>
  </div>
);

export default Footer;
